import React from "react";
import ModalWrapper from "..";
import ApprovalStatusesTable from "../../table/ApprovalStatusesTable";
import { GetAppointmentApprovalStatusesByIdResponse } from "../../../hooks/visitor/interface";
import { useTranslation } from "react-i18next";

interface ApprovalStatusesModalProps {
  approvalStatuses?: GetAppointmentApprovalStatusesByIdResponse[];
  isOpen: boolean;
  onOpenChange: () => void;
}

const ApprovalStatusesModal = ({
  approvalStatuses,
  isOpen,
  onOpenChange,
}: ApprovalStatusesModalProps) => {
  const { t } = useTranslation();

  return (
    <ModalWrapper isOpen={isOpen} onOpenChange={onOpenChange}>
      <div className="flex flex-col gap-5 justify-center items-center">
        {approvalStatuses && approvalStatuses.length > 0 && (
          <p className="text-2xl font-medium">{t("approvalStatus")}</p>
        )}
        {approvalStatuses && approvalStatuses.length > 0 ? (
          <div className="">
            <ApprovalStatusesTable approvalStatuses={approvalStatuses} />
          </div>
        ) : (
          <p className="text-base">{t("notYetApproved")}</p>
        )}
      </div>
    </ModalWrapper>
  );
};

export default React.memo(ApprovalStatusesModal);
